module.exports = __webpack_public_path__ + "static/media/cambodia.c984b523.svg";